module.exports = __webpack_public_path__ + "static/media/icon-home.79b013bc.svg";